import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';

import ScrollProgress from './components/innovher/ScrollProgress';
import Navbar from './components/innovher/Navbar';
import Hero from './components/innovher/Hero';

import LifecycleStrip from './components/innovher/LifecycleStrip';
import Capabilities from './components/innovher/Capabilities';
import VenturesBeingBuilt from './components/innovher/VenturesBeingBuilt';
import Infrastructure from './components/innovher/Infrastructure';
import MoreThanPrograms from './components/innovher/MoreThanPrograms';
import InnovPulseSection from './components/innovher/InnovPulseSection';
import StudioISection from './components/innovher/StudioISection';
import TheTeamSection from './components/innovher/TheTeamSection';
import TheNetworkSection from './components/innovher/TheNetworkSection';
import Portfolio from './components/innovher/Portfolio';
import Thesis from './components/innovher/Thesis';
import Dispatch from './components/innovher/Dispatch';
import Footer from './components/innovher/Footer';

import SectorPage from './components/pages/SectorPage';
import FounderPage from './components/pages/FounderPage';
import AcceleratorProgramPage from './components/pages/AcceleratorProgramPage';
import VentureStudioPage from './components/pages/VentureStudioPage';
import InnovationPartnersPage from './components/pages/InnovationPartnersPage';
import Xlr8arPage from './components/pages/Xlr8arPage';
import SixMonthCelebrationPage from './components/pages/SixMonthCelebrationPage';
import VosaFuturepreneursPage from './components/pages/VosaFuturepreneursPage';
import D2cSummitPage from './components/pages/D2cSummitPage';
import PsAcceleratorSeriesPage from './components/pages/PsAcceleratorSeriesPage';
import RssPage from './components/pages/RssPage';
import LoginPage from './components/pages/LoginPage';
import AboutPage from './components/pages/AboutPage';
import TeamPage from './components/pages/TeamPage';
import NetworkPage from './components/pages/NetworkPage';
import ApplyPage from './components/pages/ApplyPage';
import ContactPage from './components/pages/ContactPage';
import StoryPostPage from './components/pages/StoryPostPage';
import SEO from './components/SEO';
import CompanyPage from './components/pages/CompanyPage';
import ArchitecturePage from './components/pages/ArchitecturePage';
import InnovAcePage from './components/pages/InnovAcePage';
import InnovVedaPage from './components/pages/InnovVedaPage';
import InnovIdeaPage from './components/pages/InnovIdeaPage';
import StudioIPage from './components/pages/StudioIPage';
import InnovZPage from './components/pages/InnovZPage';
import InnovPulsePage from './components/pages/InnovPulsePage';
import IssiPage from './components/pages/IssiPage';
import FootprintPage from './components/pages/FootprintPage';

import AdminLayout from './components/accelerator/admin/AdminLayout';
import FounderLayout from './components/accelerator/founder/FounderLayout';
import AdminOverviewPage from './components/accelerator/admin/pages/AdminOverviewPage';
import ContactsPage from './components/accelerator/admin/pages/ContactsPage';
import ApplicationsPage from './components/accelerator/admin/pages/ApplicationsPage';
import ApplicationDetailPage from './components/accelerator/admin/pages/ApplicationDetailPage';
import AdminOnboardingBoardPage, {
  AdminOnboardingQueuePage,
} from './components/accelerator/admin/pages/AdminOnboardingBoardPage';
import {
  AdminBatchesPage,
  AdminBatchDetailPage,
  AdminStartupsPage,
  AdminFormBuilderPage,
  AdminUsersPage,
  AdminInvitesPage,
  AdminConfigPage,
} from './components/accelerator/admin/pages/AdminProgramPages';
import AdminStartupDossierPage from './components/accelerator/admin/pages/AdminStartupDossierPage';
import AdminDailyTasksPage from './components/accelerator/admin/pages/AdminDailyTasksPage';
import AdminMentorsPage from './components/accelerator/admin/pages/AdminMentorsPage';
import AdminMentorDetailPage from './components/accelerator/admin/pages/AdminMentorDetailPage';
import {
  FounderOverviewPage,
  FounderApplicationPage,
  FounderOnboardingBoardPage,
  FounderCompanyProfilePage,
  FounderDdPage,
  FounderBatchPage,
  FounderBatchTasksPage,
  FounderMeetingsPage,
  FounderProfilePage,
  FounderSettingsPage,
  FounderDocumentsPage,
  NotificationsPage,
} from './components/accelerator/founder/pages/FounderPortalPages';
import MentorLayout from './components/accelerator/mentor/MentorLayout';
import MentorOverviewPage from './components/accelerator/mentor/pages/MentorOverviewPage';
import MentorStartupsPage from './components/accelerator/mentor/pages/MentorStartupsPage';
import MentorStartupDetailPage from './components/accelerator/mentor/pages/MentorStartupDetailPage';
import MentorCalendarPage from './components/accelerator/mentor/pages/MentorCalendarPage';
import MentorTasksPage from './components/accelerator/mentor/pages/MentorTasksPage';
import MentorSettingsPage from './components/accelerator/mentor/pages/MentorSettingsPage';
import InvestorLayout from './components/accelerator/investor/InvestorLayout';
import InvestorDealflowPage from './components/accelerator/investor/pages/InvestorDealflowPage';
import ForgotPasswordPage from './components/pages/ForgotPasswordPage';
import ResetPasswordPage from './components/pages/ResetPasswordPage';
import AcceptInvitePage from './components/pages/AcceptInvitePage';

import StartupLayout from './components/accelerator/startup/StartupLayout';
import StartupLoginPage from './components/accelerator/startup/pages/StartupLoginPage';
import StartupOverviewPage from './components/accelerator/startup/pages/StartupOverviewPage';
import StartupProfilePage from './components/accelerator/startup/pages/StartupProfilePage';
import StartupVaultPage from './components/accelerator/startup/pages/StartupVaultPage';
import StartupRoadmapPage from './components/accelerator/startup/pages/StartupRoadmapPage';
import StartupCalendarPage from './components/accelerator/startup/pages/StartupCalendarPage';
import StartupInvestorReadinessPage from './components/accelerator/startup/pages/StartupInvestorReadinessPage';
import StartupMetricsPage from './components/accelerator/startup/pages/StartupMetricsPage';
import StartupSupportPage from './components/accelerator/startup/pages/StartupSupportPage';

const DASHBOARD_PATHS = [
  '/admin',
  '/founder',
  '/founder-dashboard',
  '/mentor-dashboard',
  '/investor-dashboard',
  '/startup',
  '/startup-dashboard',
  '/notifications',
];

function RevealObserver() {
  const loc = useLocation();
  useEffect(() => {
    const revealVisible = () => {
      const els = document.querySelectorAll('.reveal-up:not(.is-revealed)');
      els.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight + 120 && rect.bottom > -120) {
          el.classList.add('is-revealed');
        }
      });
    };

    revealVisible();
    const timeout = setTimeout(revealVisible, 150);
    window.addEventListener('scroll', revealVisible, { passive: true });
    window.addEventListener('resize', revealVisible, { passive: true });

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('scroll', revealVisible);
      window.removeEventListener('resize', revealVisible);
    };
  }, [loc.pathname]);
  return null;
}

function HashScroll() {
  const loc = useLocation();
  useEffect(() => {
    if (loc.hash) {
      const el = document.getElementById(loc.hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 50);
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [loc.pathname, loc.hash]);
  return null;
}

function AppLayout({ children }) {
  const loc = useLocation();
  const isDashboard = DASHBOARD_PATHS.some((p) => loc.pathname === p || loc.pathname.startsWith(`${p}/`));
  // Marketing /founder note moved to /founders-note; /founder is portal
  const isFounderPortal = loc.pathname === '/founder' || loc.pathname.startsWith('/founder/');
  if (isDashboard || isFounderPortal) return <>{children}</>;
  return (
    <>
      <ScrollProgress />
      <Navbar />
      <HashScroll />
      <RevealObserver />
      <main className="min-h-screen bg-[#08080a] text-white antialiased selection:bg-[#d42b92]/30">
        {children}
      </main>
      <Footer />
    </>
  );
}

const Home = () => (
  <>
    <SEO
      path="/"
      title="Startup Accelerators | Business Growth & Startup Mentorship"
      description="Discover startup accelerators offering expert mentorship, business growth consulting, and proven strategies to help your startup succeed."
      keywords="InnovHer, venture builder India, where ambition becomes enterprise, InnovACE, InnovVentures, InnovIdea, InnovVeda, Studio-I, InnovPulse, InnovZ, iSSi, Jaipur"
    />
    <Hero />
    <Capabilities />
    {/* 1. Venture content together */}
    <VenturesBeingBuilt />
    {/* 2. InnovAce content */}
    {/* 3. Infrastructure content together */}
    <Infrastructure />
    <StudioISection />
    <InnovPulseSection />
    {/* 4. Rest of ecosystem content */}
    {/* <Portfolio /> */}
    <LifecycleStrip />
    <Thesis />
    <MoreThanPrograms />
    <TheTeamSection />
    <TheNetworkSection />
    <Dispatch />
  </>
);

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/innovace" element={<InnovAcePage />} />
      <Route path="/innoveda" element={<InnovVedaPage />} />
      <Route path="/innovidea" element={<InnovIdeaPage />} />
      <Route path="/studio-i" element={<StudioIPage />} />
      <Route path="/innovz" element={<InnovZPage />} />
      <Route path="/innovpulse" element={<InnovPulsePage />} />
      <Route path="/issi" element={<IssiPage />} />
      <Route path="/footprint" element={<FootprintPage />} />
      <Route path="/portfolio" element={<Navigate to="/innovace" replace />} />
      <Route path="/capabilities/innovace" element={<Navigate to="/innovace" replace />} />
      <Route path="/capabilities/innoveda" element={<Navigate to="/innoveda" replace />} />
      <Route path="/capabilities/innovidea" element={<Navigate to="/innovidea" replace />} />
      <Route path="/ventures/innovidea" element={<Navigate to="/innovidea" replace />} />
      <Route path="/infrastructure/studio-i" element={<Navigate to="/studio-i" replace />} />
      <Route path="/infrastructure/innovpulse" element={<Navigate to="/innovpulse" replace />} />
      <Route path="/infrastructure/issi" element={<Navigate to="/issi" replace />} />
      <Route path="/ventures/innovz" element={<Navigate to="/innovz" replace />} />
      <Route path="/ventures/:slug" element={<CompanyPage />} />
      <Route path="/capabilities/:slug" element={<ArchitecturePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/the-team" element={<TeamPage />} />
      <Route path="/about/team" element={<TeamPage />} />
      <Route path="/network" element={<NetworkPage />} />
      <Route path="/about/network" element={<NetworkPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/founders-note" element={<FounderPage />} />
      <Route path="/apply" element={<ApplyPage />} />
      <Route path="/build" element={<Navigate to="/contact" replace />} />
      <Route path="/stories" element={<Navigate to="/issi" replace />} />
      <Route path="/stories/:slug" element={<StoryPostPage />} />
      <Route path="/sectors/:slug" element={<SectorPage />} />
      <Route path="/initiatives/accelerator-program" element={<AcceleratorProgramPage />} />
      <Route path="/initiatives/venture-studio" element={<VentureStudioPage />} />
      <Route path="/ecosystem/innovation-partners" element={<InnovationPartnersPage />} />
      <Route path="/events/xlr8ar" element={<Xlr8arPage />} />
      <Route path="/events/6-month-celebration" element={<SixMonthCelebrationPage />} />
      <Route path="/events/vosa-futurepreneurs" element={<VosaFuturepreneursPage />} />
      <Route path="/events/d2c-summit" element={<D2cSummitPage />} />
      <Route path="/events/9-ps-accelerator-series" element={<PsAcceleratorSeriesPage />} />
      <Route path="/publication/rss" element={<RssPage />} />

      {/* Legacy old-site URLs → public nav pages only (hidden pages stay in code, not as targets) */}
      <Route path="/about-us.php" element={<Navigate to="/about" replace />} />
      <Route path="/about.php" element={<Navigate to="/about" replace />} />
      <Route path="/about-us" element={<Navigate to="/about" replace />} />
      <Route path="/founder-words" element={<Navigate to="/about" replace />} />
      <Route path="/founder-words.php" element={<Navigate to="/about" replace />} />
      <Route path="/founders-words" element={<Navigate to="/about" replace />} />
      <Route path="/initiative.php" element={<Navigate to="/innovace" replace />} />
      <Route path="/initiative" element={<Navigate to="/innovace" replace />} />
      <Route path="/AccelerationPartners.php" element={<Navigate to="/about" replace />} />
      <Route path="/accelerationpartners.php" element={<Navigate to="/about" replace />} />
      <Route path="/acceleration-partners" element={<Navigate to="/about" replace />} />
      <Route path="/patrons" element={<Navigate to="/issi" replace />} />
      <Route path="/patrons.php" element={<Navigate to="/issi" replace />} />
      <Route path="/innohver-startup-portfolio(new).php" element={<Navigate to="/innovace" replace />} />
      <Route path="/innovher-startup-portfolio(new).php" element={<Navigate to="/innovace" replace />} />
      <Route path="/innovher-startup-portfolio.php" element={<Navigate to="/innovace" replace />} />
      <Route path="/portfolio.php" element={<Navigate to="/innovace" replace />} />
      <Route path="/9P’s-Accelerator-Series.php" element={<Navigate to="/footprint" replace />} />
      <Route path="/9Ps-Accelerator-Series.php" element={<Navigate to="/footprint" replace />} />
      <Route path="/9ps-accelerator-series.php" element={<Navigate to="/footprint" replace />} />
      <Route path="/innov-6month-celebration.php" element={<Navigate to="/footprint" replace />} />
      <Route path="/ai-day-for-startups-2025" element={<Navigate to="/footprint" replace />} />
      <Route path="/ai-day-for-startups-2025.php" element={<Navigate to="/footprint" replace />} />
      <Route path="/lifetech.php" element={<Navigate to="/" replace />} />
      <Route path="/life-tech.php" element={<Navigate to="/" replace />} />
      <Route path="/startup-in-india.php" element={<Navigate to="/issi" replace />} />
      <Route path="/rajasthan-startup-boom.php" element={<Navigate to="/issi" replace />} />
      <Route path="/social-media-pre" element={<Navigate to="/issi" replace />} />
      <Route path="/social-media-presence.php" element={<Navigate to="/issi" replace />} />
      <Route path="/contact.php" element={<Navigate to="/contact" replace />} />
      <Route path="/contact-us.php" element={<Navigate to="/contact" replace />} />
      <Route path="/apply.php" element={<Navigate to="/apply" replace />} />
      <Route path="/index.php" element={<Navigate to="/" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/invite/:token" element={<AcceptInvitePage />} />
      <Route path="/notifications" element={<NotificationsPage />} />

      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminOverviewPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="applications" element={<ApplicationsPage />} />
        <Route path="applications/:id" element={<ApplicationDetailPage />} />
        <Route path="questionnaire" element={<AdminFormBuilderPage kind="apply" />} />
        <Route path="company-profile" element={<AdminFormBuilderPage kind="profile" />} />
        <Route path="due-diligence" element={<AdminFormBuilderPage kind="dd" />} />
        <Route path="onboarding" element={<AdminOnboardingQueuePage />} />
        <Route path="onboarding/:startupId" element={<AdminOnboardingBoardPage />} />
        <Route path="batches" element={<AdminBatchesPage />} />
        <Route path="batches/:id" element={<AdminBatchDetailPage />} />
        <Route path="batches/:batchId/startups/:startupId" element={<AdminStartupDossierPage />} />
        <Route path="startups" element={<AdminStartupsPage />} />
        <Route path="mentors" element={<AdminMentorsPage />} />
        <Route path="mentors/:mentorId" element={<AdminMentorDetailPage />} />
        <Route path="daily-tasks" element={<AdminDailyTasksPage />} />
        <Route path="my-tasks" element={<Navigate to="/admin/daily-tasks" replace />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="invites" element={<AdminInvitesPage />} />
        <Route path="config" element={<AdminConfigPage />} />
        {/* Legacy redirects */}
        <Route path="dashboard" element={<Navigate to="/admin" replace />} />
        <Route path="requests" element={<Navigate to="/admin/applications" replace />} />
        <Route path="onboarded" element={<Navigate to="/admin/batches" replace />} />
        <Route path="onboarded/*" element={<Navigate to="/admin/batches" replace />} />
      </Route>

      <Route path="/founder" element={<FounderLayout />}>
        <Route index element={<FounderOverviewPage />} />
        <Route path="application" element={<FounderApplicationPage />} />
        <Route path="application/form" element={<ApplyPage />} />
        <Route path="company-profile" element={<FounderCompanyProfilePage />} />
        <Route path="onboarding" element={<FounderOnboardingBoardPage />} />
        <Route path="requests" element={<FounderDdPage />} />
        <Route path="requests/dd" element={<Navigate to="/founder/requests" replace />} />
        <Route path="dd" element={<Navigate to="/founder/requests" replace />} />
        <Route path="documents" element={<FounderDocumentsPage />} />
        <Route path="batch" element={<FounderBatchPage />} />
        <Route path="batch/tasks" element={<FounderBatchTasksPage />} />
        <Route path="meetings" element={<FounderMeetingsPage />} />
        <Route path="profile" element={<FounderProfilePage />} />
        <Route path="settings" element={<FounderSettingsPage />} />
      </Route>

      <Route path="/founder-dashboard/*" element={<Navigate to="/founder" replace />} />

      <Route path="/mentor-dashboard" element={<MentorLayout />}>
        <Route index element={<MentorOverviewPage />} />
        <Route path="startups" element={<MentorStartupsPage />} />
        <Route path="startup/:id" element={<MentorStartupDetailPage />} />
        <Route path="calendar" element={<MentorCalendarPage />} />
        <Route path="tasks" element={<MentorTasksPage />} />
        <Route path="settings" element={<MentorSettingsPage />} />
        <Route path="meetings" element={<Navigate to="/mentor-dashboard/calendar" replace />} />
      </Route>

      <Route path="/investor-dashboard" element={<InvestorLayout />}>
        <Route index element={<InvestorDealflowPage />} />
      </Route>

      {/* Startup Workspace Routes (matches /mentor-dashboard pattern) */}
      <Route path="/startup-dashboard/login" element={<Navigate to="/login" replace />} />
      <Route path="/startup/login" element={<Navigate to="/login" replace />} />
      <Route path="/startup-dashboard" element={<StartupLayout />}>
        <Route index element={<StartupOverviewPage />} />
        <Route path="profile" element={<StartupProfilePage />} />
        <Route path="vault" element={<StartupVaultPage />} />
        <Route path="documents" element={<StartupVaultPage />} />
        <Route path="roadmap" element={<StartupRoadmapPage />} />
        <Route path="tasks" element={<StartupRoadmapPage />} />
        <Route path="calendar" element={<StartupCalendarPage />} />
        <Route path="investor-readiness" element={<StartupInvestorReadinessPage />} />
        <Route path="metrics" element={<StartupMetricsPage />} />
        <Route path="support" element={<StartupSupportPage />} />
        <Route path="settings" element={<StartupSupportPage />} />
        <Route path="resources" element={<StartupSupportPage />} />
      </Route>
      <Route path="/startup" element={<Navigate to="/startup-dashboard" replace />} />
      <Route path="/startup/*" element={<Navigate to="/startup-dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppLayout>
          <AppRoutes />
        </AppLayout>
      </BrowserRouter>
    </div>
  );
}

export default App;
